"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
function Component(component) {
    return function (...args) {
        let instance = new component(...args);
        const proto = component.prototype;
        let data = {};
        Object.getOwnPropertyNames(proto).forEach(function (key) {
            if (key === 'constructor') {
                return;
            }
            const descriptor = Object.getOwnPropertyDescriptor(proto, key);
            if (descriptor.value !== void 0) {
                if (typeof descriptor.value === 'function') {
                    data[key] = descriptor.value;
                }
            }
            else if (descriptor.get || descriptor.set) {
                Object.defineProperty(data, key, { get: descriptor.get, set: descriptor.set });
            }
        });
        return Object.assign(data, instance);
    };
}
exports.default = Component;
